<!-- <div class="flex-container">
  <div class="width80">
    <mat-form-field class="w-100">
      <input matInput [(ngModel)]="item.product" value="item.product" placeholder="Concepto" aria-label="Concepto"
        [matAutocomplete]="auto" [formControl]="conceptCtrl" class="" required autocomplete="off">
      <mat-autocomplete #auto="matAutocomplete" (change)="displayFn"
        class="concept-mat-autocomplete" classList="concept-mat-autocomplete">
        <mat-option *ngFor="let concept of filteredConcepts | async; trackBy: trackByIndex" [value]="concept.name">
          <span>{{ concept.name }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="two-column">
    <mat-form-field class="list-element-item  mt-2">
      <input matInput placeholder="Unidades" type="text" [(ngModel)]="item.quantity" value="line.quantity" class=""
        required numberDecimalsDirective>
    </mat-form-field>

    <br />

    <mat-form-field class="list-element-item  mt-2">
      <input matInput placeholder="Precio" type="text" [(ngModel)]="item.unityAmount" value="line.unityAmount"
        class="" required numberDecimalsDirective>
    </mat-form-field>
  </div>

  <div class="two-column">
    <mat-form-field class="list-element-item  mt-2">
      <input matInput placeholder="Descuento (%)" type="text" [(ngModel)]="item.discount" value="line.discount"
        class="" numberDecimalsDirective>
    </mat-form-field>

    <br />

    <mat-form-field class="list-element-item  mt-2">
      <mat-select placeholder="Añadir Impuestos" #t (selectionChange)="setTax(t.value, item)" panelClass="general-mat-select">
        <mat-option selected disabled>Impuestos</mat-option>
        <mat-option *ngFor="let tax of taxes; trackBy: trackByIndex" [value]="tax">
          {{ tax.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="width80 mb-3">
    <convfact-chips-component [chipsElements]="item.taxes" [container]="this" [changeFunction]="changeChips">
    </convfact-chips-component>
  </div>

</div> -->

<div class="row">
  <div class="col-md-12">
    <mat-form-field class="w-100">
      <input matInput [(ngModel)]="item.product" value="item.product" placeholder="Concepto" aria-label="Concepto"
        [matAutocomplete]="auto" [formControl]="conceptCtrl" class="" required autocomplete="off">
      <mat-autocomplete #auto="matAutocomplete" class="concept-mat-autocomplete" classList="concept-mat-autocomplete">
        <mat-option *ngFor="let concept of filteredConcepts | async; trackBy: trackByIndex" [value]="concept.name"
          (click)="displayFn(concept)">
          <span>{{ concept.name }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 col-tablet">
    <mat-form-field class="w-100">
      <input matInput placeholder="Unidades" type="textbox" [(ngModel)]="item.quantity" value="line.quantity" class=""
        required numberDecimalsDirective>
    </mat-form-field>
  </div>

  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 col-tablet">
    <mat-form-field class="w-100">
      <input matInput placeholder="Precio" type="textbox" [(ngModel)]="item.unityAmount" value="line.unityAmount"
        class="" required numberDecimalsDirective>
    </mat-form-field>
  </div>

  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 col-tablet">
    <mat-form-field class="w-100">
      <input matInput placeholder="Descuento (%)" type="textbox" [(ngModel)]="item.discount" value="line.discount"
        class="" numberDecimalsDirective>
    </mat-form-field>
  </div>

  <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-tablet">
    <app-autocomplete-select [items]="taxes" [idField]="'id'" [displayField]="'name'" placeholder="Añadir Impuestos"
      (selectionChanged)="onSelectTax($event)">
    </app-autocomplete-select>
  </div>

  <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 col-tablet">
    <convfact-chips-component [chipsElements]="item.taxes" [container]="this" [changeFunction]="changeChips">
    </convfact-chips-component>
  </div>

  <div class="col-md-12">
    <span class="ms-2"> Total Linea: {{calcularTotalesLinea(item)}} </span>
  </div>

</div>

<button type="button" mat-stroked-button (click)="onSave()" class="pull-right" style="margin-left: 10px;">
  <mat-icon>save</mat-icon>
  Guardar
</button>
<button mat-button class="btn btn-danger pull-right" (click)="onCancel()">Cancelar</button>

<!-- <div class="flex-container">
  <div class="width80">
    <mat-form-field class="w-100">
      <input matInput [(ngModel)]="item.product" value="item.product" placeholder="Concepto" aria-label="Concepto"
        [matAutocomplete]="auto" [formControl]="conceptCtrl" class="" required autocomplete="off">
      <mat-autocomplete #auto="matAutocomplete" (change)="displayFn" class="concept-mat-autocomplete"
        classList="concept-mat-autocomplete">
        <mat-option *ngFor="let concept of filteredConcepts | async; trackBy: trackByIndex" [value]="concept.name">
          <span>{{ concept.name }}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="two-column">
    <mat-form-field class="list-element-item  mt-2">
      <input matInput placeholder="Unidades" type="textbox" [(ngModel)]="item.quantity" value="line.quantity" class=""
        required numberDecimalsDirective>
    </mat-form-field>

    <br />

    <mat-form-field class="list-element-item  mt-2">
      <input matInput placeholder="Precio" type="textbox" [(ngModel)]="item.unityAmount" value="line.unityAmount"
        class="" required numberDecimalsDirective>
    </mat-form-field>
  </div>

  <div class="two-column">
    <mat-form-field class="list-element-item  mt-2">
      <input matInput placeholder="Descuento (%)" type="textbox" [(ngModel)]="item.discount" value="line.discount"
        class="" numberDecimalsDirective>
    </mat-form-field>

    <br />

    <mat-form-field class="list-element-item  mt-2">
      <mat-select placeholder="Añadir Impuestos" #t (selectionChange)="setTax(t.value, item)" panelClass="general-mat-select">
        <mat-option selected disabled>Impuestos</mat-option>
        <mat-option *ngFor="let tax of taxes; trackBy: trackByIndex" [value]="tax">
          {{ tax.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="width80 mb-3">
    <convfact-chips-component [chipsElements]="item.taxes" [container]="this" [changeFunction]="changeChips">
    </convfact-chips-component>
  </div>

</div> -->
